var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePasswosrd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.895,
    height: 24.032,
    viewBox: "0 0 20.895 24.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "changePasswosrd",
    transform: "translate(1 1.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M6.6,16.5H21.3a2.153,2.153,0,0,1,2.1,2.2V26.41a2.153,2.153,0,0,1-2.1,2.2H6.6a2.153,2.153,0,0,1-2.1-2.2V18.7a2.153,2.153,0,0,1,2.1-2.2Z",
    transform: "translate(-4.5 -6.584)",
    fill: "none",
    stroke: "#5e2b97",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M10.5,12.908V8.5A5.415,5.415,0,0,1,15.221,3.02,5.288,5.288,0,0,1,20.892,7.4",
    transform: "translate(-6.301 -2.992)",
    fill: "none",
    stroke: "#5e2b97",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswosrd);
export default __webpack_public_path__ + "static/media/changePasswosrd.72956e974dac86916a8cc65ce052b4c0.svg";
export { ForwardRef as ReactComponent };